<template>
  <ErrorModal v-if="error.show" :data="error.data" :load-times="true" />
  <reservationheader :step="2" />
  <reservationinfobar :step="2" />
  <div
    class="orm-container-fluid orm-reservation__data__container orm-reservation__data__container__extra"
    v-if="selectedCargroup && selectedCargroupInfo"
  >
    <div class="orm-container">
      <div class="orm-row">
        <div class="orm-col-xs-12 orm-col-md-9">
          <div class="orm-reservation__data__container__inner orm-my-16">
            <h1 class="orm-headline__h1">{{ i18n("step2/headline") }}</h1>
            <div class="orm-row">
              <div class="orm-col-xs-12 orm-col-sm-5">
                <Slider v-if="images" :images="images" />
                <div class="orm-carequip__centered">
                  <div class="orm-carequip">
                    <p
                      class="orm-equip__txt__icons orm-mt-8"
                      v-if="selectedCargroupInfo"
                    >
                      <equipIcon :data="selectedCargroupInfo.features" />
                    </p>
                  </div>
                </div>
              </div>

              <div class="orm-col-xs-12 orm-col-sm-7">
                <div class="orm-border-left">
                  <h2 class="orm-headline__h2">
                    {{
                      stripHTML(
                        selectedCargroupInfo[env.VUE_APP_RESERVATION_CARGROUP]
                      )
                    }}
                  </h2>
                  <p class="orm-headline__h3__subheadline orm-relative">
                    {{
                      stripHTML(
                        selectedCargroupInfo[
                          env.VUE_APP_RESERVATION_CARCATEGORY
                        ]
                      )
                    }}
                    <i class="fal fa-question-circle orm-cargroup__tooltip"
                      ><span
                        class="orm-cargroup__tooltip_text orm-cargroup__tooltip-bottom"
                        >{{ i18n("cargroup/noguarantee") }}</span
                      ></i
                    >
                  </p>
                  <div
                    v-html="
                      selectedCargroupInfo[env.VUE_APP_RESERVATION_CARTEXT]
                    "
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <!-- TARIFE START -->
          <div
            class="orm-reservation__data__container__inner orm-my-16"
            v-if="mainrates"
          >
            <div class="orm-row orm-relative">
              <div class="orm-col-xs-12">
                <h3 class="orm-headline__h3">{{ i18n("step2/tarifs") }}</h3>
                <div
                  v-for="mainrate in mainrates"
                  :key="mainrate"
                  class="orm-list__element"
                >
                  <div class="orm-row orm-my-16">
                    <div class="orm-col-xs-12 orm-col-md-9 orm-list__bold">
                      <span v-if="mainrate.rate == 'KM'">
                        {{ mainrate.amount }}&nbsp;{{ mainrate.description }}
                        <div class="orm-extra-small" v-if="mainrate.long_price">
                          ({{
                            convertCurrency(
                              showNettoPrice
                                ? mainrate.single_price
                                : mainrate.long_price
                            )
                          }}/ {{ i18n("step2/kmRate") || "KM"
                          }}{{
                            mainrate.discount != null && mainrate.discount != 0
                              ? ", " +
                                (i18n("general/noDiscount") ||
                                  "Preis ohne Rabatt")
                              : ""
                          }})
                        </div>
                        <!-- <div
                          class="orm-extra-small"
                          v-if="
                            mainrate.discount != null && mainrate.discount != 0
                          "
                        >
                          ({{
                            i18n("general/noDiscount") || "Preis ohne Rabatt"
                          }})
                        </div> -->
                      </span>
                      <span v-else>
                        <span v-if="mainrate.amount >= 1"
                          >{{ mainrate.amount }}x
                        </span>
                        {{ mainrate.description }}
                        <span v-if="this.$store.getters['ORMgeneral/GET_PARAMETER']('BORMLF_STEP1_SHOW_TOTALPRICE_ONLY') !== '1'" class="orm-small">
                          ({{
                            convertCurrency(
                              showNettoPrice
                                ? mainrate.single_price
                                : mainrate.long_price
                            )
                          }}/{{ mainrate.unit
                          }}{{
                            mainrate.discount != null && mainrate.discount != 0
                              ? ", " +
                                (i18n("general/noDiscount") ||
                                  "Preis ohne Rabatt")
                              : ""
                          }})
                        </span>
                        <div
                          class="orm-small"
                          v-if="mainrate.description2"
                          v-html="mainrate.description2"
                        ></div>
                      </span>
                    </div>
                    <div class="orm-col-xs-12 orm-col-md-3 orm-price__right">
                      {{
                        convertCurrency(
                          showNettoPrice
                            ? mainrate.total_price
                            : mainrate.total_long_price
                        )
                      }}
                      <div
                        class="orm-extra-small"
                        v-if="
                          mainrate.discount != null && mainrate.discount != 0
                        "
                      >
                        ({{ i18n("general/discount") || "Preis mit Rabatt" }}
                        {{ mainrate.discount }}%)
                      </div>
                    </div>
                  </div>
                  <div v-if="mainrate.position == 1" class="orm-row orm-my-16">
                    <div
                      class="orm-col-xs-12 orm-col-md-9 orm-list__bold"
                      v-if="!mainrate.all_km_inclusive"
                    >
                      {{ mainrate.km_free }} {{ i18n("step2/freeKilometers") }}
                    </div>
                    <div
                      class="orm-col-xs-12 orm-col-md-9 orm-list__bold"
                      v-else
                    >
                      {{ i18n("step2/unlimited") }}
                      {{ i18n("step2/freeKilometers") }}
                    </div>
                    <div class="orm-col-xs-12 orm-col-md-3 orm-price__right">
                      {{ i18n("step2/inclusive") }}
                    </div>
                  </div>
                </div>
                <div v-if="loadingPrice" class="orm-extra__loading">
                  <div class="orm-loader-spinner">
                    <i class="fa fa-spinner-third orm-rotate360"></i>
                  </div>
                </div>
                <div
                  class="orm-list__element"
                  v-if="
                    store.getters['ORMgeneral/GET_PARAMETER'](
                      'BORM_PRESELECT_PLANNED_KM'
                    ) !== '1' &&
                      store.getters['ORMgeneral/GET_PARAMETER'](
                        'BORMLF_NO_KM_INPUT'
                      ) !== '1'
                  "
                >
                  <!--<div class="orm-list__bold">
                    <label for="distance">{{ i18n("step2/distance") }}</label>
                    <div class="orm-input orm-inline orm-withIcon">
                      <input
                        class="orm-input__control"
                        id="distance"
                        type="text"
                        required="required"
                        placeholder="KM"
                        v-model="distance"
                        @keyup.enter="setDistance()"
                        :disabled="loadingPrice"
                      />
                      <form-input
                          v-if="getVisibility('distance')"
                          my-id="formDistance"
                          :my-label="i18n('step2/distance')"
                          :is-required="getRequirement('distance')"
                          :error="validate.distance"
                          v-model="distance"
                      />
                      <i class="far fa-sync" @click="setDistance()"></i>
                    </div>
                  </div>-->
                  <div
                      class="orm-list__bold"
                      v-if="getVisibility('distance')"
                  >
                    <label for="distance">
                      {{ i18n("step2/distance") }}
                      <span v-if="getRequirement('distance')">*</span>
                    </label>
                    <div class="orm-input orm-inline orm-withIcon">
                      <input
                          ref="distanceInput"
                          id="distance"
                          type="text"
                          class="orm-input__control"
                          :class="{ 'orm-form__error': validate.distance }"
                          :required="getRequirement('distance')"
                          placeholder="KM"
                          v-model="distance"
                          @keyup.enter="setDistance"
                          :disabled="loadingPrice"
                      />
                      <i class="far fa-sync" @click="setDistance"></i>
                    </div>
                    <div v-if="validate.distance" class="orm-input__error">
                      {{ i18n("form/validation/required") }}
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="orm-row">
              <div class="orm-col-xs-12">
                <div
                  class="orm-subtotal"
                  v-if="
                    selectedCargroup.total_price_main_rates && !showNettoPrice
                  "
                >
                  {{ i18n("general/subtotal") }}:
                  {{
                    convertCurrency(
                      showNettoPrice
                        ? selectedCargroup.end_positions[0].total_price
                        : selectedCargroup.total_price_main_rates
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
          <!-- PAYMENT START -->
          <div
            v-if="
              store.getters['ORMgeneral/GET_MODULE']('ZAHLUNGSDIENSTLEISTER') ==
                'J' &&
                mainrates &&
                merchantId
            "
          >
            <div
              class="orm-reservation__data__container__inner orm-my-16 orm-relative"
              v-if="mainrates"
            >
              <div v-if="loadingPrice" class="orm-extra__loading">
                <div class="orm-loader-spinner">
                  <i class="fa fa-spinner-third orm-rotate360"></i>
                </div>
              </div>
              <div class="orm-row orm-relative">
                <div class="orm-col-xs-12">
                  <h3 class="orm-headline__h3">{{ i18n("step2/payment") }}</h3>
                </div>
              </div>
              <div class="orm-row">
                <div class="orm-col-xs-12">
                  <span v-for="category in extras" :key="category">
                    <div
                      v-if="category.id == 'PAY_'"
                      class="orm-radio__element orm-mb-16"
                    >
                      <div
                        v-for="extra in category.extras"
                        :key="extra"
                        class="orm-radio__element"
                      >
                        <div class="orm-row orm-my-16">
                          <div class="orm-col-xs-12 orm-col-md-9">
                            <form-radio
                              :my-multisize="true"
                              :my-multiline="true"
                              my-name="payment"
                              :my-label="extra.description"
                              :my-small="extra.description2"
                              :model-value="payment[extra.rate]"
                              @update:modelValue="
                                setPayment(extra.rate, extra.id, extra.amount)
                              "
                            />
                          </div>

                          <div
                            class="orm-col-xs-12 orm-col-md-3 orm-price__right"
                          >
                            <span v-if="extra.unit == 'X'">
                              {{
                                convertCurrency(
                                  showNettoPrice
                                    ? extra.total_price
                                    : extra.long_price
                                )
                              }}
                            </span>
                            <span v-else>
                              {{ convertCurrency(extra.long_price) }} /
                              {{ extra.unit }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
              <div
                class="orm-subtotal orm-mt-32"
                v-if="selectedCargroup.total_price_payment && !showNettoPrice"
              >
                {{ i18n("general/subtotal") }}:
                {{ convertCurrency(selectedCargroup.total_price_payment) }}
              </div>
            </div>
          </div>

          <!-- DELIVERY -->
          <div
            class="orm-reservation__data__container__inner orm-my-16"
            v-if="mainrates && hasDeliveryPickup"
          >
            <div class="orm-row orm-relative">
              <div class="orm-col-xs-12">
                <div v-if="loadingPrice" class="orm-extra__loading">
                  <div class="orm-loader-spinner">
                    <i class="fa fa-spinner-third orm-rotate360"></i>
                  </div>
                </div>
                <h3 class="orm-headline__h3">
                  {{ i18n("step2/deliverypickup/title") }}
                </h3>
                <div class="orm-row">
                  <div class="orm-col-xs-12 orm-col-md-10 orm-mb-16">
                    <div class="orm-mb-8">
                      <form-checkbox-simple
                        :my-name="i18n('step2/deliverypickup/delivery')"
                        :my-label="i18n('step2/deliverypickup/delivery')"
                        :my-multisize="false"
                        :model-value="delivery"
                        v-model="delivery"
                        @update:modelValue="validateDeliveryPickup"
                      ></form-checkbox-simple>
                    </div>
                    <div class="orm-form__container" v-if="delivery">
                      <form-input
                        my-id="deliveryStreet"
                        :my-label="i18n('step2/deliverypickup/deliveryStreet')"
                        :disabled="loadingPrice"
                        :error="deliveryPickupError.deliveryStreet"
                        :model-value="deliveryPickup.deliveryStreet"
                        v-model="deliveryPickup.deliveryStreet"
                      ></form-input>
                      <div class="orm-row">
                        <div class="orm-col-xs-12 orm-col-md-4">
                          <form-input
                            my-id="deliveryZipcode"
                            :my-label="
                              i18n('step2/deliverypickup/deliveryZipcode')
                            "
                            :disabled="loadingPrice"
                            :error="deliveryPickupError.deliveryZipcode"
                            :model-value="deliveryPickup.deliveryZipcode"
                            v-model="deliveryPickup.deliveryZipcode"
                          ></form-input>
                        </div>
                        <div class="orm-col-xs-12 orm-col-md-8">
                          <form-input
                            my-id="deliveryCity"
                            :my-label="
                              i18n('step2/deliverypickup/deliveryCity')
                            "
                            :disabled="loadingPrice"
                            :error="deliveryPickupError.deliveryCity"
                            :model-value="deliveryPickup.deliveryCity"
                            v-model="deliveryPickup.deliveryCity"
                          ></form-input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="orm-col-xs-12 orm-col-md-10 orm-mb-16">
                    <div class="orm-mb-8">
                      <form-checkbox-simple
                        :my-name="i18n('step2/deliverypickup/pickup')"
                        :my-label="i18n('step2/deliverypickup/pickup')"
                        :my-multisize="false"
                        :model-value="pickup"
                        v-model="pickup"
                        @update:modelValue="validateDeliveryPickup"
                      ></form-checkbox-simple>
                    </div>
                    <div class="orm-form__container" v-if="pickup">
                      <form-input
                        my-id="pickupStreet"
                        :my-label="i18n('step2/deliverypickup/pickupStreet')"
                        :disabled="loadingPrice"
                        :error="deliveryPickupError.pickupStreet"
                        :model-value="deliveryPickup.pickupStreet"
                        v-model="deliveryPickup.pickupStreet"
                      ></form-input>
                      <div class="orm-row">
                        <div class="orm-col-xs-12 orm-col-md-4">
                          <form-input
                            my-id="pickupZipcode"
                            :my-label="
                              i18n('step2/deliverypickup/pickupZipcode')
                            "
                            :disabled="loadingPrice"
                            :error="deliveryPickupError.pickupZipcode"
                            :model-value="deliveryPickup.pickupZipcode"
                            v-model="deliveryPickup.pickupZipcode"
                          ></form-input>
                        </div>
                        <div class="orm-col-xs-12 orm-col-md-8">
                          <form-input
                            my-id="pickupCity"
                            :my-label="i18n('step2/deliverypickup/pickupCity')"
                            :disabled="loadingPrice"
                            :error="deliveryPickupError.pickupCity"
                            :model-value="deliveryPickup.pickupCity"
                            v-model="deliveryPickup.pickupCity"
                          ></form-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="orm-row">
                  <div class="orm-col-xs-12 orm-col-md-10 text-right">
                    <div class="orm-form__container">
                      <button
                        class="orm-button__cta outline small"
                        @click="validateDeliveryPickup"
                        v-if="pickup || delivery"
                      >
                        {{ i18n("step2/deliverypickup/calculate") }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="orm-row orm-mt-16">
                  <div class="orm-col-xs-12">
                    <div
                      class="orm-list__element"
                      v-for="rates in deliveryrates"
                      :key="rates"
                    >
                      <div class="orm-row orm-my-16">
                        <div class="orm-col-xs-12 orm-col-md-9 orm-list__bold">
                          {{ rates.description }}: {{ rates.amount }}
                          {{ rates.unit }}
                        </div>
                        <div
                          class="orm-col-xs-12 orm-col-md-3 orm-price__right"
                        >
                          {{
                            convertCurrency(
                              showNettoPrice
                                ? rates.total_price
                                : rates.total_long_price
                            )
                          }}
                        </div>
                      </div>
                    </div>

                    <div
                      class="orm-subtotal orm-mt-32"
                      v-if="
                        selectedCargroup.total_price_delivery_pickup &&
                          !showNettoPrice
                      "
                    >
                      {{ i18n("general/subtotal") }}:
                      {{
                        convertCurrency(
                          selectedCargroup.total_price_delivery_pickup
                        )
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- EXTRAS START -->
          <span v-for="category in extras" :key="category.id">
            <div
              v-if="category && category.id == 'CDW'"
              class="orm-reservation__data__container__inner orm-my-16"
            >
              <div class="orm-row">
                <div class="orm-col-xs-12">
                  <h3 class="orm-headline__h3">{{ category.name }}</h3>
                  <div class="orm-relative">
                    <div v-if="loadingPrice" class="orm-extra__loading">
                      <div class="orm-loader-spinner">
                        <i class="fa fa-spinner-third orm-rotate360"></i>
                      </div>
                    </div>
                    <div
                      v-for="extra in category.extras"
                      :key="extra"
                      class="orm-radio__element"
                    >
                      <div class="orm-row orm-my-16">
                        <div class="orm-col-xs-12 orm-col-md-9">
                          <FormCheckboxconditional
                            :my-multisize="true"
                            :my-multiline="true"
                            my-name="cdw"
                            :my-label="
                              extra.contribution >= 0 &&
                              extra.contribution != null
                                ? extra.description +
                                  ' (' +
                                  contribution +
                                  convertCurrency(extra.contribution) +
                                  ')'
                                : extra.description
                            "
                            :my-small="extra.description2"
                            :conditional="extra.required"
                            :model-value="insurance[extra.rate]"
                            @update:modelValue="setInsurance(extra)"
                          />
                        </div>
                        <div
                          class="orm-col-xs-12 orm-col-md-3 orm-price__right"
                        >
                          <span v-if="extra.unit == 'MAX'">
                            {{
                              convertCurrency(
                                showNettoPrice
                                  ? extra.total_price
                                  : extra.long_price
                              )
                            }}
                          </span>
                          <span
                            v-else-if="
                              (extra.long_price == '0' ||
                                extra.long_price == '0,0001') &&
                                store.getters['ORMgeneral/GET_PARAMETER'](
                                  'BORM_SHOW_ZERO_PRICE_AS_INCLUSIVE'
                                ) == 1
                            "
                          >
                            {{ i18n("step2/inclusive") }}
                          </span>
                          <span v-else>
                            {{
                              convertCurrency(
                                showNettoPrice
                                  ? extra.single_price
                                  : extra.long_price
                              )
                            }}
                            /
                            {{ extra.unit }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="orm-row">
                    <div class="orm-col-xs-12">
                      <div
                        class="orm-subtotal"
                        v-if="
                          selectedCargroup.total_price_insurance &&
                            !showNettoPrice
                        "
                      >
                        {{ i18n("general/subtotal") }}:
                        {{
                          convertCurrency(
                            selectedCargroup.total_price_insurance
                          )
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>

          <div
            class="orm-reservation__data__container__inner orm-mt-16 orm-mb-16"
            v-if="extras.length > 0"
          >
            <div class="orm-row">
              <div class="orm-col-xs-12">
                <div class="orm-row">
                  <div class="orm-col-xs-9" style="align-self: center">
                    <h3 class="orm-headline__h3__extras">
                      {{ i18n("step2/extras") }}
                    </h3>
                  </div>
                  <div class="orm-col-xs-3 orm-price__right">
                    <div
                      v-if="extrasRequired == false"
                      class="orm-extras__button"
                    >
                      <i
                        :class="{
                          'fal fa-plus-circle orm-extras__button__closed': !extrasVisible,
                          'fal fa-minus-circle orm-extras__button__open': extrasVisible,
                        }"
                        @click="extrasVisible = !extrasVisible"
                      ></i>
                    </div>
                  </div>
                </div>

                <div
                  class="orm-relative orm-pt-16"
                  :class="{ 'orm-extras__container__closed': !extrasVisible }"
                >
                  <div v-if="loadingPrice" class="orm-extra__loading">
                    <div class="orm-loader-spinner">
                      <i class="fa fa-spinner-third orm-rotate360"></i>
                    </div>
                  </div>
                  <span v-for="category in extras" :key="category">
                    <span v-if="category.id == 'CDW' || category.id == 'PAY_'">
                    </span>
                    <div v-else class="orm-mb-32">
                      <p class="orm-headline__h3__subheadline orm-mb-8">
                        {{ category.name }}
                      </p>
                      <div
                        v-for="extra in category.extras"
                        :key="extra"
                        class="orm-row orm-mt-8 orm-mb-16"
                      >
                        <div class="orm-col-xs-12 orm-col-md-9">
                          <form-checkbox
                            :my-name="extra.rate"
                            :my-label="extra.description"
                            :my-small="extra.description2"
                            :my-multisize="true"
                            :required="extra.required"
                            :model-value="selectedExtras[extra.rate]"
                            :amount-real="extra.amount_real"
                            :min-amount="extra.min_amount"
                            :max-amount="extra.max_amount"
                            :unit="extra.unit"
                            @update:modelValue="
                              setExtra(extra.rate, extra.id, $event)
                            "
                          ></form-checkbox>
                        </div>
                        <div
                          class="orm-col-xs-12 orm-col-md-3 orm-price__right"
                        >
                          <span
                            v-if="
                              (extra.long_price == '0' ||
                                extra.long_price == '0,0001') &&
                                store.getters['ORMgeneral/GET_PARAMETER'](
                                  'BORM_SHOW_ZERO_PRICE_AS_INCLUSIVE'
                                ) == 1
                            "
                          >
                            {{ i18n("step2/inclusive") }}
                          </span>
                          <span v-else>
                            {{
                              convertCurrency(
                                showNettoPrice
                                  ? extra.single_price
                                  : extra.long_price
                              )
                            }}
                            <span
                              v-if="extra.unit != 'MAX' && extra.unit !== 'X'"
                              >/&nbsp;{{ extra.unit }}</span
                            >
                          </span>
                        </div>
                      </div>
                    </div>
                  </span>
                  <div class="orm-row">
                    <div class="orm-col-xs-12">
                      <div
                        class="orm-subtotal"
                        v-if="
                          selectedCargroup.total_price_subrates &&
                            !showNettoPrice
                        "
                      >
                        {{ i18n("general/subtotal") }}:
                        {{
                          convertCurrency(selectedCargroup.total_price_subrates)
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- EXTRAS END -->

          <!-- VOUCHER -->
          <div
            class="orm-reservation__data__container__inner orm-my-16 orm-mb-32"
          >
            <div class="orm-row orm-relative">
              <div v-if="loadingPrice" class="orm-extra__loading">
                <div class="orm-loader-spinner">
                  <i class="fa fa-spinner-third orm-rotate360"></i>
                </div>
              </div>
              <div class="orm-col-xs-12">
                <h3 class="orm-headline__h3">
                  {{ i18n("step2/voucher/title") }}
                </h3>
                <div class="orm-list__element">
                  <div class="orm-row orm-my-16 orm-valignCenter">
                    <div class="orm-col-xs-12 orm-col-sm-6 orm-list__bold">
                      <label for="vouchercode">{{
                        i18n("step2/voucher/label")
                      }}</label>
                    </div>
                    <div class="orm-col-xs-12 orm-col-sm-6 orm-input__right">
                      <div
                        class="orm-input orm-inline orm-withIcon orm-withIcon__wide"
                      >
                        <input
                          class="orm-input__control"
                          id="vouchercode"
                          type="text"
                          placeholder="Gutscheincode eingeben"
                          v-model="vouchercode"
                          @keyup.enter="checkVoucher()"
                          :disabled="loadingPrice"
                          :class="{ 'orm-form__error': vouchercodeError }"
                        />
                        <i class="far fa-sync" @click="checkVoucher()"></i>
                        <p v-if="vouchercodeError" class="orm-voucher__error">
                          {{ i18n("step2/voucher/error") }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-if="vouchercodeValid">
                    <div
                      v-for="voucher in voucherrates"
                      :key="voucher.id"
                      class="orm-row orm-my-16 orm-valignCenter"
                    >
                      <div class="orm-col-xs-12 orm-col-md-9 orm-list__bold">
                        {{ voucher.description }}<br /><span
                          class="orm-small"
                          v-if="!showNettoPrice"
                          >{{ voucher.description2 }}</span
                        >
                      </div>
                      <div class="orm-col-xs-12 orm-col-md-3 orm-price__right">
                        {{
                          convertCurrency(
                            showNettoPrice
                              ? voucher.single_price
                              : voucher.total_long_price
                          )
                        }}
                      </div>
                    </div>
                  </div>
                  <div v-if="vouchercodeValid" class="orm-subtotal orm-mt-32">
                    {{ i18n("general/subtotal") }}:
                    {{
                      convertCurrency(
                        showNettoPrice
                          ? selectedCargroup.voucher_rates[0].single_price
                          : selectedCargroup.total_price_voucher
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="orm-col-xs-12 orm-col-md-3">
          <Scrollcontainer>
            <div
              class="orm-priceCalculator"
              v-if="selectedCargroup.end_positions"
            >
              <div class="orm-relative">
                <div
                  v-if="loadingPrice"
                  class="orm-extra__loading orm-extra__loading--alt"
                >
                  <div class="orm-loader-spinner">
                    <i class="fa fa-spinner-third orm-rotate360"></i>
                  </div>
                </div>
                <div v-if="showNettoPrice">
                  <span
                    v-if="selectedCargroup.end_positions[0].rate == 'NS.'"
                    class="description"
                  >
                    {{ i18n("general/total") }}:
                  </span>
                  <span v-if="position.rate == 'ES.'" class="orm-pricetag">
                    <em>{{
                      convertCurrency(
                        selectedCargroup.end_positions[0].total_price
                      )
                    }}</em>
                  </span>
                </div>
                <div
                  v-for="(position, index) in selectedCargroup.end_positions"
                  :key="index"
                  class="orm-price-item flex-container"
                >
                  <span
                    v-if="position.rate == 'MWST' && position.rate != 'ES.'"
                    class="description"
                  >
                    {{ i18n("general/vat") || position.description }} ({{
                      convertCurrency(position.single_price)
                    }}):
                  </span>
                  <span
                    v-if="position.rate != 'MWST' && position.rate != 'ES.'"
                    class="description"
                  >
                    {{ i18n("general/netamount") || position.description }}:
                  </span>
                  <span
                    v-if="position.rate != 'ES.'"
                    class="orm-price_item_right"
                  >
                    {{ convertCurrency(position.total_price) }}
                  </span>
                  <span v-if="position.rate == 'ES.'" class="description">
                    <em>{{ i18n("general/total") }}:</em>
                  </span>
                  <span v-if="position.rate == 'ES.'" class="orm-pricetag">
                    <em>{{ convertCurrency(position.total_price) }}</em>
                  </span>
                </div>
              </div>
              <p class="orm-smallprint"></p>
              <button
                v-if="!loadingPrice"
                @click="setReservation"
                class="orm-button__cta outline small wide"
              >
                {{ i18n("general/nextstep") }}
              </button>
            </div>
          </Scrollcontainer>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
import { defineComponent } from "vue";
// import router from "@/router";
import reservationheader from "@/components/reservation/header.vue"; // @ is an alias to /src
import reservationinfobar from "@/components/reservation/infobar_disabled.vue"; // @ is an alias to /src
import equipIcon from "@/components/reservation/equip-icon.vue";
import Slider from "@/components/ui/image-slider.vue";
import Scrollcontainer from "@/components/ui/scrollcontainer.vue";
import FormInput from "@/components/ui/INPUTS/FormInput.vue"; // @ is an alias to /src
import FormCheckbox from "@/components/ui/INPUTS/FormCheckboxExtras.vue";
import FormCheckboxSimple from "@/components/ui/INPUTS/FormCheckbox.vue";
import FormCheckboxconditional from "@/components/ui/INPUTS/FormCheckboxconditional.vue";

import FormRadio from "@/components/ui/INPUTS/FormRadio.vue";
import ErrorModal from "@/components/modals/modal-error.vue";

import { convertCurrency } from "@/constants/formater";

import store from "@/store";
import Footer from "@/components/widgets/Footer.vue"; // @ is an alias to /src
import i18n from "@/mixins/mixins";
import stripHTML from "@/mixins/mixins";
import { buildDataLayer } from "@/constants/analytics";
import { routeToSteps } from "@/constants/getRoutes";

export default defineComponent({
  name: "ReservationStep2",
  props: { data: Object, type: String },
  mixins: [i18n, stripHTML],
  data() {
    return {
      env: process.env,
      stationSelected: store.getters["userSession/GET_STATION"],
      carID: String,
      selectedCargroup: Object,
      selectedDate: Object,
      selectedTime: Object,
      mainrates: Array,
      subrates: Array,
      deliveryrates: Array,
      voucherrates: Array,
      endpositions: Array,
      selectedCargroupInfo: {},
      images: null,
      extras: Array,
      contribution: this.i18n("step2/contribution") || "SB: ",
      selectedExtras: store.getters["reservation/GET_EXTRAS"],
      distance: store.getters["reservation/GET_RESERVATION_DISTANCE"],
      convertCurrency,
      insuranceRequired: false,
      extrasRequired: false,
      testradio: true,
      extrasVisible: false,
      insurance: {},
      payment: {},
      loadingPrice: false,
      paymentCondardis: false,
      hasDeliveryPickup: false,
      deliveryPickup: {},
      delivery: false,
      pickup: false,
      deliveryPickupError: {
        deliveryStreet: false,
        deliveryZipcode: false,
        deliveryCity: false,
        pickupStreet: false,
        pickupZipcode: false,
        pickupCity: false,
      },
      vouchercode: null,
      vouchercodeValid: null,
      vouchercodeError: false,
      error: {
        show: false,
        data: {
          header: this.i18n("error/tocarselect/header"),
          content: this.i18n("error/tocarselect/content"),
          buttonFirst: "Home",
          buttonFirstLabel: this.i18n("error/tocarselect/buttonFirstLabel"),
        },
      },
      merchantId: null,
      showSaleTax: true,
      showNettoPrice: false,
      validate: {},
      requirements: null,
      errors: [],
    };
  },
  components: {
    reservationheader,
    reservationinfobar,
    Footer,
    equipIcon,
    Slider,
    FormCheckbox,
    FormCheckboxconditional,
    FormCheckboxSimple,
    FormRadio,
    FormInput,
    ErrorModal,
    Scrollcontainer,
  },
  setup() {
    return {
      store,
      routeToSteps,
    };
  },
  async created() {
    this.requirements = await store.getters[
        "ORMgeneral/GET_INPUTFIELD_REQUIREMENTS"
        ]("step2_input_fields");
    this.requirements.forEach((element) => {
      if (element.required) this.validate[element.name] = false;
    });
  },
  async mounted() {
    const showTax = await store.getters["ORMgeneral/GET_PARAMETER"](
      "BORM_HIDE_TAX_TEXT"
    );
    const showNetto = await store.getters["ORMgeneral/GET_PARAMETER"](
      "BORM_SHOW_NETTO_PRICE"
    );
    switch (showTax) {
      case "1":
        this.showSaleTax = false;
        break;
      default:
        break;
    }
    switch (showNetto) {
      case "1":
        this.showNettoPrice = true;
        break;
      default:
        break;
    }
    const stationsel = await store.getters["userSession/GET_STATION"];
    if (stationsel == null) {
      this.error.show = true;
      return false;
    }
    // console.log(store.getters["ORMgeneral/GET_MODULE"]("ORM_PICKUP_DELIVERY"));
    if (
      process.env.VUE_APP_DELIVERYPICKUP == "true" &&
      store.getters["ORMgeneral/GET_MODULE"]("ORM_PICKUP_DELIVERY") == "J" &&
      store.getters["stations/GET_STATION_BY_ID"](stationsel)
        .pickup_and_delivery_is_enabled == true
    ) {
      this.hasDeliveryPickup = true;
    }
    store.dispatch("payment/DELETE_CONCARDIS");
    store.dispatch("reservation/DELETE_SUCCESS_RESERVATION");

    const deliveryPickup = await store.getters[
      "reservation/GET_DELIVERY_PICKUP"
    ];
    this.deliveryPickup = JSON.parse(JSON.stringify(deliveryPickup));
    this.delivery = deliveryPickup.deliveryStreet !== "" ? true : false;
    this.pickup = deliveryPickup.pickupStreet !== "" ? true : false;

    const carID = await store.getters["reservation/GET_RESERVATION_CARGROUP"]();
    this.carID = carID;

    if (carID == null) {
      this.error.show = true;
      return false;
    }

    this.selectedCargroupInfo = await store.getters[
      "cargroup/GET_CARGROUP_BY_ID"
    ](carID);

    if (this.selectedCargroupInfo == undefined) {
      // console.log("this.selectedCargroupInfo", this.selectedCargroupInfo);
      this.error.show = true;
      return false;
    }

    this.images = await store.getters["cargroup/GET_GLOBAL_CARGROUPS_IMAGE"](
      carID
    );
    this.selectedCargroup = await store.getters["reservation/GET_RESERVATION"];

    if (this.selectedCargroup == null) {
      this.error.show = true;
      return false;
    }

    this.selectedDate = await store.getters["reservation/GET_RESERVATION_DATE"];

    if (this.selectedDate == null) {
      this.error.show = true;
      return false;
    }

    this.selectedTime = await store.getters["reservation/GET_RESERVATION_TIME"];

    if (this.selectedTime == null) {
      this.error.show = true;
      return false;
    }
    const branch = await store.getters["stations/GET_STATION_BY_ID"](
      this.stationSelected
    ).branch;
    if (
      (branch == "Auto-Abo" && this.$route.name != "Abo_Step2") ||
      (branch != "Auto-Abo" && this.$route.name != "Reservation_Step2")
    ) {
      this.error.show = true;
      return false;
    }

    if (
      (await store.getters["ORMgeneral/GET_MODULE"]("ZAHLUNGSDIENSTLEISTER")) ==
      "J"
    ) {
      const merchantId = await store.dispatch(
        "payment/GET_CONCARDIS_MERCHANDID"
      );
      this.merchantId = merchantId != "error" ? merchantId : null;
    }

    this.subrates = this.selectedCargroup.sub_rates;
    this.mainrates = this.selectedCargroup.main_rates;
    this.mainrates.sort((a, b) => (a.position > b.position ? 1 : -1));
    this.deliveryrates = this.selectedCargroup.delivery_pickup_rates;
    this.endpositions = this.selectedCargroup.end_positions;
    this.voucherrates = this.selectedCargroup.voucher_rates;

    const extras = await store.getters["reservation/GET_EXTRA_CATEGORIES"];

    if (extras == null) {
      await store
        .dispatch(
          "reservation/SET_CATEGORIES",
          this.selectedCargroup.main_rates[0]
        )
        .then((res) => {
          this.extras = res;
          this.selectedExtras = store.getters["reservation/GET_EXTRAS"];
          this.selectedInsurance = store.getters["reservation/GET_INSURANCE"];
          // console.log(" this.selectedExtras", this.selectedExtras);
          if (
            Object.keys(this.selectedExtras).length > 0 ||
            Object.keys(this.selectedInsurance).length > 0
          ) {
            this.extrasVisible = true;
            this.calcPrice();
          }
        });
    } else {
      this.extras = extras;
      this.selectedExtras = await store.getters["reservation/GET_EXTRAS"];
      if (Object.keys(this.selectedExtras).length > 0) {
        this.extrasVisible = true;
      }
    }

    for (const extras in this.extras) {
      const extra = this.extras[extras].extras.find((x) => x.required == true);
      if (extra && extra.rate.includes("CDW")) {
        this.insuranceRequired = extra;
      }
    }
    if (
      store.getters["ORMgeneral/GET_PARAMETER"]("BINET_SHOW_ZUSRATES_OPEN") ==
      "1"
    ) {
      this.extrasVisible = true;
    }

    this.payment = await store.getters["reservation/GET_PAYMENTTYPE"];
    this.insurance = await store.getters["reservation/GET_INSURANCE"];

    if (
      this.payment &&
      this.subrates.length == 0 &&
      store.getters["ORMgeneral/GET_MODULE"]("ConCardis") == "J"
    ) {
      // this.calcPrice();
    }

    // this.extras.forEach((element) => {
    //   element.extras.forEach((element) => {
    //     if (element.required == true) {
    //       if (element.rate.includes("CDW")) {
    //         this.insuranceRequired = true;
    //       }
    //     }
    //   });
    // });

    this.vouchercode = await store.getters["reservation/GET_VOUCHERCODE"];
    this.vouchercodeValid = this.vouchercode;

    buildDataLayer("view_item", {}, null);
    // console.log(this.insurance);
    // this.checkVoucher();
  },
  methods: {
    getRequirement(input) {
      const required = this.requirements.find((x) => x.name === input);
      return required ? required.required : null;
    },
    getVisibility(input) {
      const visible = this.requirements.find((x) => x.name === input);
      console.log(input,visible);
      return visible ? visible.visible : null;
    },
    async calcPrice() {
      this.loadingPrice = true;
      // console.log(this.carID);
      this.selectedCargroup = await store
        .dispatch("reservation/CALCULATE_PRICE", {
          id: this.carID,
          extras: true,
        })
        .then((res) => {
          if (!res.errors) {
            store.dispatch("reservation/SET_RESERVATION_TARIFS", res);
            this.subrates = res.sub_rates;
            this.mainrates = JSON.parse(JSON.stringify(res.main_rates));
            this.deliveryrates = JSON.parse(
              JSON.stringify(res.delivery_pickup_rates)
            );
            this.endpositions = res.end_positions;
            this.mainrates.sort((a, b) => (a.position > b.position ? 1 : -1));
            this.loadingPrice = false;
            if (res.voucher_rates) {
              if (res.voucher_rates.length > 0) {
                this.voucherrates = JSON.parse(
                  JSON.stringify(res.voucher_rates)
                );
              } else {
                this.voucherrates = null;
                this.vouchercodeValid = null;

                if (this.vouchercode != null) {
                  if (this.vouchercode !== "") {
                    this.vouchercodeError = true;
                  }
                }
              }
            }
            buildDataLayer("view_item", {}, null);
            return res;
          } else {
            console.log("errors", res);
          }
        });
    },
    setDistance() {
      this.loadingPrice = true;
      store
        .dispatch("reservation/SET_DRIVEDISTANCE", this.distance)
        .then((res) => {
          this.calcPrice();
          return res;
        });
    },

    setInsurance(extra) {
      this.loadingPrice = true;
      if (this.insuranceRequired && this.insurance[extra.rate]) {
        extra = this.insuranceRequired;
      }
      const rate = extra.rate;
      const id = extra.id;
      const amount = extra.amount;
      store
        .dispatch("reservation/SET_INSURANCE", { rate, id, amount })
        .then((res) => {
          this.calcPrice();
          this.insurance = store.getters["reservation/GET_INSURANCE"];
          return res;
        });
    },
    setPayment(rate, id, amount) {
      this.loadingPrice = true;
      store
        .dispatch("reservation/SET_PAYMENTTYPE", { rate, id, amount })
        .then((res) => {
          this.calcPrice();
          return res;
        });
    },
    setExtra(rate, id, amount) {
      this.loadingPrice = true;
      store
        .dispatch("reservation/SET_EXTRAS", { rate, id, amount })
        .then((res) => {
          this.calcPrice();
          this.selectedExtras = store.getters["reservation/GET_EXTRAS"];
          return res;
        });
    },
    async validateForm() {
      this.errors = [];

      for (const formfield in this.validate) {
        if (!Object.hasOwnProperty.call(this, formfield)) continue;

        const value = this[formfield];

        if (this.getVisibility(formfield) && this.getRequirement(formfield)) {
          if (formfield === "distance" && value <= 0) {
            this.errors.push(formfield + " required.");
          }
          if (!value) {
            this.validate[formfield] = true;
            this.errors.push(formfield + " required.");
          } else {
            this.validate[formfield] = false;
          }
        } else {
          this.validate[formfield] = false;
        }
      }
      return this.errors.length <= 0;
    },
    async setReservation() {
      if (await this.validateForm()) {
        await store
            .dispatch("reservation/CALCULATE_PRICE", {
              id: this.carID,
              extras: true,
            })
            .then((res) => {
              if (!res.errors) {
                if (
                    res.end_positions[2].total_price !==
                    this.endpositions[2].total_price
                ) {
                  console.log("end check calc", res.end_positions[2].total_price);
                  console.log("end old calc", this.endpositions[2].total_price);
                  console.log("ns check calc", res.end_positions[0].total_price);
                  console.log("ns old calc", this.endpositions[0].total_price);
                  console.log("all check calc", res);
                  console.log(
                      "all old calc",
                      JSON.parse(JSON.stringify(this.selectedCargroup))
                  );
                  this.error.show = true;
                  this.error.data.header = this.i18n("error/wrongpricecalc/header");
                  this.error.data.content = this.i18n(
                      "error/wrongpricecalc/content"
                  );
                  this.error.data.buttonFirst = "Reservation_Step1";
                } else {
                  buildDataLayer("add_to_cart", {}, null);
                  buildDataLayer("begin_checkout", {}, null);
                  store
                      .dispatch(
                          "reservation/SET_RESERVATION_TARIFS",
                          this.selectedCargroup
                      )
                      .then(() => {
                        routeToSteps(this, 3);
                      });
                }
              } else {
                this.error.show = true;
              }
            });
      } else {
        if (this.validate.distance) {
          const distanceElement = this.$refs.distanceInput;

          if (distanceElement) {
            distanceElement.focus();
          }
        }
      }
    },
    validateDeliveryPickup() {
      let error = false;

      if (this.delivery) {
        if (this.deliveryPickup.deliveryStreet == "") {
          error = true;
          this.deliveryPickupError.deliveryStreet = true;
        } else {
          this.deliveryPickupError.deliveryStreet = false;
        }
        if (this.deliveryPickup.deliveryZipcode == "") {
          error = true;
          this.deliveryPickupError.deliveryZipcode = true;
        } else {
          this.deliveryPickupError.deliveryZipcode = false;
        }
        if (this.deliveryPickup.deliveryCity == "") {
          error = true;
          this.deliveryPickupError.deliveryCity = true;
        } else {
          this.deliveryPickupError.deliveryCity = false;
        }
      } else {
        this.deliveryPickup.deliveryStreet = "";
        this.deliveryPickup.deliveryZipcode = "";
        this.deliveryPickup.deliveryCity = "";
      }
      if (this.pickup) {
        if (this.deliveryPickup.pickupStreet == "") {
          error = true;
          this.deliveryPickupError.pickupStreet = true;
        } else {
          this.deliveryPickupError.pickupStreet = false;
        }
        if (this.deliveryPickup.pickupZipcode == "") {
          error = true;
          this.deliveryPickupError.pickupZipcode = true;
        } else {
          this.deliveryPickupError.pickupZipcode = false;
        }
        if (this.deliveryPickup.pickupCity == "") {
          error = true;
          this.deliveryPickupError.pickupCity = true;
        } else {
          this.deliveryPickupError.pickupCity = false;
        }
      } else {
        this.deliveryPickup.pickupStreet = "";
        this.deliveryPickup.pickupCity = "";
        this.deliveryPickup.pickupCity = "";
      }

      if (!error) {
        store
          .dispatch("reservation/SET_DELIVERY_PICKUP", this.deliveryPickup)
          .then(() => {
            this.calcPrice();
          });
      }
    },
    async checkVoucher() {
      if (this.vouchercode == null || this.vouchercode === "") {
        this.vouchercodeError = false;
        return;
      }

      await store
        .dispatch("reservation/CHECK_VOUCHER", this.vouchercode)
        .then((result) => {
          if (result) {
            this.vouchercodeValid = this.vouchercode;
            this.vouchercodeError = false;
            this.calcPrice();
          } else {
            this.vouchercodeError = true;
          }
        });
    },
  },
});
</script>
